function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "link");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "iPhone-XS-Copy-3",
  transform: "translate(-33.000000, -281.000000)"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(23.000000, 265.000000)"
}, React.createElement("g", {
  id: "link",
  transform: "translate(8.000000, 8.000000)"
}, React.createElement("polygon", {
  id: "Path",
  points: "0 0 29 0 29 29 0 29"
}), React.createElement("path", {
  d: "M4.7125,14.5 C4.7125,12.43375 6.39208333,10.7541667 8.45833333,10.7541667 L13.2916667,10.7541667 L13.2916667,8.45833333 L8.45833333,8.45833333 C5.12333333,8.45833333 2.41666667,11.165 2.41666667,14.5 C2.41666667,17.835 5.12333333,20.5416667 8.45833333,20.5416667 L13.2916667,20.5416667 L13.2916667,18.2458333 L8.45833333,18.2458333 C6.39208333,18.2458333 4.7125,16.56625 4.7125,14.5 Z M9.66666667,15.7083333 L19.3333333,15.7083333 L19.3333333,13.2916667 L9.66666667,13.2916667 L9.66666667,15.7083333 Z M20.5416667,8.45833333 L15.7083333,8.45833333 L15.7083333,10.7541667 L20.5416667,10.7541667 C22.6079167,10.7541667 24.2875,12.43375 24.2875,14.5 C24.2875,16.56625 22.6079167,18.2458333 20.5416667,18.2458333 L15.7083333,18.2458333 L15.7083333,20.5416667 L20.5416667,20.5416667 C23.8766667,20.5416667 26.5833333,17.835 26.5833333,14.5 C26.5833333,11.165 23.8766667,8.45833333 20.5416667,8.45833333 Z",
  id: "Shape",
  fill: "currentColor",
  fillRule: "nonzero"
})))));

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "25px",
    height: "13px",
    viewBox: "0 0 25 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link.4d3c4ced.svg";
export { ForwardRef as ReactComponent };